// Rámovaná fotografie v decentním rámu se zlatou linií.
// Výchozí: portrét Daniela (/public/images/daniel-pekar-portret.webp).
// Lze použít i pro jinou fotku přes props src/alt/caption.
export const Portrait = ({
  size = "large",
  caption = "Daniel Pekař",
  eager = false,
  src = "/images/daniel-pekar-portret.webp",
  alt = "Daniel Pekař — osobní poradce pro pojištění",
  width = 1000,
  height = 1212,
  testId,
}) => {
  const isLarge = size === "large";
  return (
    <figure
      data-testid={testId || `portrait-${size}`}
      className={`relative w-full ${isLarge ? "max-w-md" : "max-w-sm"}`}
    >
      <div
        className="absolute -bottom-4 -right-4 w-full h-full border border-[#B69A58]/40 pointer-events-none"
        aria-hidden="true"
      />
      <div className="relative border border-[#E5E5E5] bg-white p-3">
        <div className="absolute top-0 left-8 w-16 h-[1px] bg-[#B69A58]" aria-hidden="true" />
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : "auto"}
          className="w-full h-auto block"
        />
      </div>
      {caption && (
        <figcaption className="mt-6 text-xs uppercase tracking-[0.25em] text-[#737373] text-center">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};
